// Interval for checking if token needs to be refreshed (in seconds)
export const REFRESH_TOKEN_CHECK_INTERVAL = 60;

// Token is refreshed if token expires within the minimum validity time (in
// seconds)
export const REFRESH_TOKEN_MIN_VALIDITY = 70;
